export const convertBalanceView = (balance: number, decimalPlaces: number = 2): string => {
    // Приводим к числу
    const num = Number(balance || 0);

    // Форматируем целую часть с разделителями
    const integerPart = Math.trunc(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // Форматируем дробную часть
    const fractional = Math.abs(num % 1);
    const fractionalPart = fractional.toFixed(decimalPlaces).slice(2).padEnd(decimalPlaces, '0');

    return `${integerPart}${decimalPlaces > 0 ? '.' : ''}${fractionalPart}`;

}